import * as React from 'react';
import Wrapper from './Wrapper';

const ReverseTime = Wrapper(props => (
  <svg
    width="18"
    height="18"
    viewBox="-4 2 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.10938 12.7318L8.10871 10.7318L8.10938 7.39844"
      stroke="#696970"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.4401 5.57031L6.77344 3.40365L9.77344 1.87031"
      stroke="#696970"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.47266 13.3973C3.11234 14.4002 4.01272 15.2101 5.07738 15.7405C6.14205 16.2708 7.33093 16.5017 8.51671 16.4082C9.7025 16.3148 10.8405 15.9006 11.809 15.21C12.7775 14.5195 13.5399 13.5785 14.0146 12.4879C14.4893 11.3973 14.6585 10.1981 14.504 9.01867C14.3495 7.83929 13.8771 6.72413 13.1375 5.79259C12.3979 4.86106 11.4188 4.14822 10.3052 3.7304C9.19149 3.31259 7.98516 3.20553 6.81532 3.42068"
      stroke="#696970"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.56773 4.28906C3.75934 4.78895 3.06756 5.45641 2.53906 6.2464"
      stroke="#696970"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.55659 8.66406C1.38851 9.59915 1.41803 10.5591 1.64326 11.4821"
      stroke="#696970"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export default ReverseTime;
